<template>
	<div class="homePageSetting-body">
		<div class="top-header">
			<div class="top-left-box">
				<i class="el-icon-back" @click="goBack"></i><div class="scheme-name">{{editNameText}}</div>
				<el-button type="primary" size="mini" @click='editName' v-if="AuthorityList['16_0004_0002_00']">编辑</el-button>
				<div>
					<div style="display: flex;align-items: center;height: 40px;">
						<div style="width:90px;text-align: right;">
							关联店铺：
						</div>
						<el-radio style="min-height: 40px;;line-height: 40px;" v-model="shopattendway" :label="1">全部门店</el-radio>
						<el-radio style="min-height: 40px;;line-height: 40px;" v-model="shopattendway" :label="0">自定义门店</el-radio>
						<div  v-if="shopattendway === 0" @click="bindShopClick" style="height: 20px;line-height: 20px;margin-left:10px;color:var(--fx-primary-color);cursor: pointer;font-size: 12px;">
							<i style="font-size: 14px;" class="el-icon-circle-plus"></i>
							选择门店
						</div>
						<div v-if="shopattendway === 0" style="display: flex;align-items: center;min-height: 40px;">
							<div style="width:60px;text-align: right;flex-shrink: 0;">
								已选：
							</div>
							<div class="shop-text" :title="shopText">{{shopText}}</div>
						</div>
					</div>
				</div>
			</div>
			<div>
				<el-button type="primary" v-if="AuthorityList['16_0004_0002_00']" size="mini" @click='saveClick'>保存</el-button>
			</div>
		</div>
		<div class="fx-header header-box">
			<p class="header-title">采购页装修编辑</p>
			<div class="save-btn-box">
				<div class="switch-tetx">
				</div>
			</div>
		</div>
		<div class="body-box">
			<div class="home-page-left">
				<div class="component-title">
					<i class="el-icon-arrow-down margin-right-10"></i>
					基础组件
				</div>
					<draggable filter=".forbid" v-model="componentList" :options="{group:{name: 'itxst',pull:'clone'},sort: false}" @end='end1' :disabled="disable" animation="300" :move="onMove" ghostClass="ghost" chosenClass="chosen" >
						<transition-group class="component-box">
							<div v-for="(item, index) in componentList" :key='index' class="item-box" :class="item.allNum === item.num ? 'item forbid' : ''">
								<img v-if="item.type === 2 && !isSelect" src="~/images/icon/notice-icon.png"/>
								<img v-if="item.type === 2 && isSelect" src="~/images/icon/notice-icon1.png"/>
								<img v-if="item.type === 3 && !isSelect" src="~/images/icon/advert-icon.png"/>
								<img v-if="item.type === 3 && isSelect" src="~/images/icon/advert-icon1.png"/>
								<img v-if="item.type === 5 && !isSelect" src="~/images/icon/product-icon.png"/>
								<img v-if="item.type === 5 && isSelect" src="~/images/icon/product-icon1.png"/>
								<div>{{item.name}}</div>
								<div>{{item.num}}/{{item.allNum}}</div>
							</div>
						</transition-group>
					</draggable>
			</div>
			<div class="home-page-center">
				<div class="phone">
					<img style="width: 375px;" src="~/images/icon/phone-title.png"/>
					<div style="display:block;width: 375px;background-color: #F1F3F6;" v-for="(item, index) in homeArr" :key="index">
						<div class="notice-box phone-component  item forbid" v-if="item.type === 2" :class="(item.chooseArr) ? 'isSelect' : ''">
							<div v-if="item.chooseArr" class="phone-component-btn-box">
								<img @click="moveClick(index, 'del')" src="~/images/icon/del-btn.png"/>
							</div>
							<div @click="selectClick(item,index)" class="notice-container">
								<img src="~/images/icon/announcement-icon.png"/>
								<marquee behavior="scroll" direction="left" scrollamount="4" style="width: 100%;">{{item.data.detail}}</marquee >
							</div>
							<div class="phone-component-text">
								<img src="~/images/icon/notice-text.png" />
							</div>
						</div>
					</div>
					<draggable filter=".forbid" v-model="homeArr" style="min-height:100px;flex-shrink:0" :scroll="true" group="itxst" ghostClass="ghost" @end='end2' chosenClass="chosen" @start="start2" animation="300">
						<transition-group style="display:block;flex:1;height:100%;width: 375px;background-color: #F1F3F6;">
							<div style="width: 100%;" v-for="(item, index) in homeArr" :key="index" :class="(item.chooseArr && item.type !== 2) ? 'isSelect' : ''">
								<div class="phone-component" v-if="item.type === 3">
									<div v-if="item.chooseArr" class="phone-component-btn-box">
										<img @click="moveClick(index, 'up')" src="~/images/icon/up-btn.png"/>
										<img @click="moveClick(index, 'down')" src="~/images/icon/down-btn.png"/>
										<img @click="moveClick(index, 'del')" src="~/images/icon/del-btn.png"/>
									</div>
									<div class="phone-component-text">
										<img src="~/images/icon/advert-text.png" />
									</div>
									<div @click="selectClick(item,index)" v-if="item.data.template === 1">
										<div v-show='item.data.dataList.length === 0' class="advert-img">
											<img class="defaultImg" src="~/images/icon/advert-default.png"/>
											<span>点击编辑图片广告</span>
										</div>
										<div v-show="item.data.dataList.length > 0" v-for="(data, index) in item.data.dataList" :key="index" class="advert-img">
											<img v-if="data.imgurl === ''" class="defaultImg" src="~/images/icon/advert-default.png"/>
											<w-image v-if="data.imgurl !== ''" :src="data.imgurl" style="width:100%;height:100%"></w-image>
										</div>
									</div>
									<div @click="selectClick(item,index)" v-if="item.data.template === 2" style="height:100px;">
										<div v-show='item.data.dataList.length === 0' class="advert-img">
											<img class="defaultImg" src="~/images/icon/advert-default.png"/>
											<span>点击编辑图片广告</span>
										</div>
										<el-carousel height="100px" style="width:375px">
											<el-carousel-item v-show="item.data.dataList.length > 0" v-for="(data, index) in item.data.dataList" :key="index">
												<w-image style="width:100%;height:100%;" v-if="data.imgurl !== ''" :src="data.imgurl"></w-image>
												<img style="width:60px;height:45px;" v-if="data.imgurl === ''" src="~/images/icon/advert-default.png"/>
											</el-carousel-item>
										</el-carousel>
									</div>
								</div>
								<div class="phone-component" v-if="item.type === 5">
									<div v-if="item.chooseArr" class="phone-component-btn-box">
										<img @click="moveClick(index, 'up')" src="~/images/icon/up-btn.png"/>
										<img @click="moveClick(index, 'down')" src="~/images/icon/down-btn.png"/>
										<img @click="moveClick(index, 'del')" src="~/images/icon/del-btn.png"/>
									</div>
									<div class="phone-component-text">
										<img src="~/images/icon/pro-text.png" />
									</div>
									<div @click="selectClick(item,index)" class="progroup-box">
										<div v-if="item.data.name !== ''" class="progroup-title">
											<div class="title-img"></div>
											<div class="title-name">{{item.data.name}}</div>
										</div>
										<img v-if="item.data.template === 1" src="~/images/icon/progroup-1.png"/>
										<img v-if="item.data.template === 2" src="~/images/icon/progroup-2.png"/>
										<img v-if="item.data.template === 3" src="~/images/icon/progroup-3.png"/>
									</div>
								</div>
							</div>
						</transition-group>
					</draggable>
					<img style="width: 375px;" src="~/images/icon/goodsList.png"/>
				</div>
			</div>
			<div class="home-page-right">
				<componentBox ref="componentBox" :showChange="false" @reloadData='reloadData'></componentBox>
			</div>
		</div>
		<el-dialog
			title="编辑方案名称"
			:visible.sync="editNameShow"
			:close-on-click-modal="false"
			class="img-dialog"
			width="400px"
			append-to-body>
			<div style="text-align: center">
				<el-input
					style="margin-bottom: 10px;width: 300px"
					v-model="tempEditNameText"
					placeholder="请输入方案名称"
					size="mini"
					:maxlength="10"
					>
				</el-input>
				<div style="text-align: center;margin-top: 20px">
					<el-button class="btn" size="small" plain type="primary" @click="close">取消</el-button>
					<el-button class="btn" size="small" plain type="primary" @click="saveName">确认</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog
			top='100px'
			title="选择适用门店"
			class="dialog-title"
			:visible.sync="shopDialog"
			width="780px"
			append-to-body
			:close-on-click-modal="false">
			<div>
				<bindShop v-if="shopDialog" :customerDialog.sync='shopDialog' :chooseData1='chooseShop' @reloadCus='reloadShop'></bindShop>
			</div>
		</el-dialog>
		<el-dialog
			top='100px'
			title="错误信息提示"
			class="dialog-title"
			:visible.sync="errorDialog"
			width="780px"
			append-to-body
			:close-on-click-modal="false">
			<div class="error-box">
				<div v-for="item in errorList" :key="item">{{item}}</div>
			</div>
			<div style="text-align: center;margin-top: 20px">
				<el-button class="btn" size="small" plain type="primary" @click="errorDialog = false">确认</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import draggable from 'vuedraggable'
import componentBox from '@/components/homepageSetting/component.vue'
import bindShop from '@/components/bindShop/bindShop.vue'
export default {
	name: '',
	components: {
		draggable,
		componentBox,
		bindShop
	},
	data () {
		return {
			styleid: '',
			disabledflag: null,
			isSelect: false,
			disable: false,
			moveId: null,
			value: false,
			homeArr: [],
			componentList: [
				{
					type: 2,
					name: '公告',
					num: 0,
					allNum: 1,
					chooseArr: false,
					data: {
						useway: 1,
						disabledflag: 0,
						detail: ''
					}
				},
				{
					type: 3,
					name: '图片广告',
					num: 0,
					allNum: 1,
					chooseArr: false,
					data: {
						template: 2,
						dataList: []
					}
				},
				{
					type: 5,
					name: '商品组',
					num: 0,
					allNum: 1,
					chooseArr: false,
					data: {
						name: '',
						template: 2,
						dataList: []
					}
				}
			],
			AuthorityList: {
				'16_0004_0001_00': false
			},
			editNameText: '自定义采购装修方案',
			tempEditNameText: '',
			editNameShow: false,
			shopattendway: 1,
			shopText: '',
			shopDialog: false,
			chooseShop: [],
			shopList: [],
			errorDialog: false,
			errorList: []
		}
	},
	created () {
		if (this.$route.query.id) {
			this.styleid = this.$route.query.id
			this.getDetail()
		}
		this.getAuthority('16_0004_0000_00')
	},
	mounted () {
	},
	methods: {
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		goBack () {
			this.$router.push('/main/pageSettingList')
		},
		editName () {
			this.tempEditNameText = this.editNameText
			this.editNameShow = true
		},
		saveName () {
			if (!this.tempEditNameText) {
				this.$message.error('方案名称不能为空')
				return false
			}
			this.editNameText = this.tempEditNameText
			this.editNameShow = false
		},
		close () {
			this.editNameShow = false
		},
		bindShopClick () {
			this.shopDialog = true
		},
		reloadShop (data) {
			this.chooseShop = data.chooseData
			this.shopText = data.shopText
			this.shopDialog = false
		},
		swapArray (arr, index1, index2) {
			arr[index1] = arr.splice(index2, 1, arr[index1])[0]
			return arr
		},
		moveClick (index, type) {
			if (type === 'up') {
				if (index === 1) {
					return false
				}
				this.swapArray(this.homeArr, index - 1, index)
			} else if (type === 'down') {
				if (index + 1 === this.homeArr.length) {
					return false
				}
				this.swapArray(this.homeArr, index, index + 1)
			} else {
				let list = this.$fxUtils.deepClone(this.homeArr)
				list.splice(index, 1)
				if (list.length) {
					list[0].chooseArr = true
					this.$refs.componentBox.initData(list[0])
				}
				this.homeArr = list
			}
			this.end1()
		},
		reloadData () {
			this.homeArr.forEach(item => {
				if (item.chooseArr) {
					item.data = this.$refs.componentBox.getData()
				}
			})
		},
		initSaveData () {
			let data = []
			this.homeArr.forEach(item => {
				let setting = {}
				let dataList = []
				if (item.type === 1) {
					let row = {
						wordsearch: item.data.wordsearch,
						type: 0
					}
					if (item.data.wordsearch !== '') {
						dataList.push(row)
					}
					dataList = [...dataList, ...item.data.dataList]
					setting.type = item.type
				}
				if (item.type === 2) {
					let row = {
						useway: item.data.useway,
						detail: item.data.detail,
						disabledflag: item.data.disabledflag
					}
					dataList = [row]
					setting.type = item.type
				}
				if (item.type === 3) {
					dataList = item.data.dataList
					setting.template = item.data.template
					setting.type = item.type
					dataList.forEach(item => {
						if (item.imgurl !== '') {
							item.extension = item.imgurl.split('.')[item.imgurl.split('.').length - 1]
						}
					})
				}
				if (item.type === 4) {
					dataList = item.data.dataList
					setting.template = item.data.template
					setting.pattern = item.data.pattern
					setting.type = item.type
					dataList.forEach(item => {
						if (item.imgurl !== '') {
							item.extension = item.imgurl.split('.')[item.imgurl.split('.').length - 1]
						}
					})
				}
				if (item.type === 5) {
					dataList = item.data.dataList
					setting.template = item.data.template
					setting.name = item.data.name
					setting.type = item.type
					dataList.forEach(item => {
						if (item.imgurl !== '') {
							item.extension = item.imgurl.split('.')[item.imgurl.split('.').length - 1]
						}
					})
				}
				if (item.type === 6) {
					dataList = item.data.dataList
					setting.template = item.data.template
					setting.name = item.data.name
					setting.shownameflag = item.data.shownameflag
					setting.type = item.type
					dataList.forEach(item => {
						if (item.imgurl !== '') {
							item.extension = item.imgurl.split('.')[item.imgurl.split('.').length - 1]
						}
					})
				}
				if (item.type === 7) {
					dataList = item.data.dataList
					setting.type = item.type
					dataList.forEach(item => {
						if (item.imgurl !== '') {
							item.extension = item.imgurl.split('.')[item.imgurl.split('.').length - 1]
						}
					})
				}
				let dataItem = {
					dataList: dataList,
					setting: setting
				}
				data.push(dataItem)
			})
			return data
		},
		checkSave () {
			let list = this.homeArr
			let resultFlag = true
			list.forEach(item => {
				let arr = item.data.dataList
				if (item.type === 1 && resultFlag) {
					let flag = arr.every(item => {
						return item.wordsearch !== ''
					})
					if (!flag) {
						this.$message.error('搜索热词未填写!')
						resultFlag = resultFlag && false
					}
				}
				if (item.type === 2 && resultFlag) {
					if (item.data.useway === 1 && item.data.disabledflag === 0 && item.data.detail === '') {
						this.$message.error('公告内容未填写!')
						resultFlag = resultFlag && false
					}
				}
				if (item.type === 3 && resultFlag) {
					let flag = arr.every(item => {
						return item.imgurl !== ''
					})
					if (!flag) {
						this.$message.error('广告图片未上传!')
						resultFlag = resultFlag && false
					}
				}
				if (item.type === 4 && resultFlag) {
					let flag = arr.every(item => {
						return item.imgurl !== ''
					})
					if (!flag) {
						this.$message.error('导航图片未上传!')
						resultFlag = resultFlag && false
					}
					let flag1 = arr.every(item => {
						return item.name !== ''
					})
					if (!flag1 && resultFlag) {
						this.$message.error('导航标题未填写!')
						resultFlag = resultFlag && false
					}
				}
				if (item.type === 5 && resultFlag) {
					if (item.data.name === '') {
						this.$message.error('商品组标题未填写!')
						resultFlag = resultFlag && false
					}
					if (item.data.dataList.length === 0 && resultFlag) {
						this.$message.error('商品组未添加商品!')
						resultFlag = resultFlag && false
					}
				}
				if (item.type === 6 && resultFlag) {
					if (item.data.name === '') {
						this.$message.error('精品推荐标题未填写!')
						resultFlag = resultFlag && false
					}
					let flag1 = arr.every(item => {
						return item.imgurl !== ''
					})
					if (!flag1 && resultFlag) {
						this.$message.error('精品推荐图片未上传!')
						resultFlag = resultFlag && false
					}
				}
			})
			return resultFlag
		},
		saveClick () {
			if (this.shopattendway === 0 && this.chooseShop.length === 0) {
				this.$message.error('请选择关联店铺！')
				return false
			}
			if (!this.checkSave()) {
				return false
			}
			const logger = this.$fxLogger.createInfo('setting.home-page.save')
			let params = {
				type: 1,
				name: this.editNameText,
				styleid: this.styleid,
				relAllShopFlag: this.shopattendway,
				shopIds: this.chooseShop,
				disabledflag: !this.disabledflag,
				moduleList: this.initSaveData()
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/style/main/addOrUpdate`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.styleid = res.data.id
					this.$message.success('保存成功！')
					this.getDetail()
				} else {
					if (res.msg) {
						this.$message.error(res.msg)
					} else {
						this.errorList = res.data
						this.errorDialog = true
					}
				}
			})
		},
		getDetail () {
			let params = {
				type: 1,
				styleid: this.styleid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/style/getDetailInfo`,
				data: params
			}).then(res => {
				if (res.result) {
					this.editNameText = res.data.style.name
					this.shopattendway = res.data.style.relAllShopFlag
					this.chooseShop = res.data.shopIds
					this.shopText = res.data.shopNames
					this.disabledflag = !res.data.style.disabledflag
					this.styleid = res.data.style.id
					this.homeArr = this.initData(res.data.moduleList)
					let num = null
					this.homeArr.forEach((item, index) => {
						if (item.type === 1) {
							num = index
						}
					})
					if (num) {
						this.homeArr[num].chooseArr = true
						this.$refs.componentBox.initData(this.homeArr[num])
					} else {
						this.homeArr[0].chooseArr = true
						this.$refs.componentBox.initData(this.homeArr[0])
					}
					this.end1()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		initData (data) {
			let arr = []
			data.forEach(item => {
				if (item.setting.type === 1) {
					let row = {
						type: 1,
						name: '商品搜索',
						num: 0,
						allNum: 1,
						chooseArr: false,
						data: {
							wordsearch: '',
							dataList: []
						}
					}
					item.dataList.forEach(itemData => {
						if (itemData.type === 0) {
							row.data.wordsearch = itemData.wordsearch
						} else {
							row.data.dataList.push(itemData)
						}
					})
					arr.push(row)
				}
				if (item.setting.type === 2) {
					let row = {
						type: 2,
						name: '公告',
						num: 0,
						allNum: 1,
						chooseArr: false,
						data: {
							useway: item.dataList.useway,
							disabledflag: item.dataList.disabledflag ? 1 : 0,
							detail: item.dataList.detail
						}
					}
					arr.push(row)
				}
				if (item.setting.type === 3) {
					let row = {
						type: 3,
						name: '图片广告',
						num: 0,
						allNum: 5,
						chooseArr: false,
						data: {
							template: item.setting.template,
							dataList: item.dataList
						}
					}
					arr.push(row)
				}
				if (item.setting.type === 4) {
					let row = {
						type: 4,
						name: '图文导航',
						num: 0,
						allNum: 1,
						chooseArr: false,
						data: {
							template: item.setting.template,
							pattern: item.setting.pattern,
							dataList: item.dataList,
							showArr: item.setting.pattern === 1 ? item.dataList : this.initShowArr(item.setting.template, item.setting.pattern, item.dataList)
						}
					}
					arr.push(row)
				}
				if (item.setting.type === 5) {
					let row = {
						type: 5,
						name: '商品组',
						num: 0,
						allNum: 5,
						chooseArr: false,
						data: {
							name: item.setting.name,
							template: item.setting.template,
							dataList: item.dataList
						}
					}
					arr.push(row)
				}
				if (item.setting.type === 6) {
					let row = {
						type: 6,
						name: '精品推荐',
						num: 0,
						allNum: 5,
						chooseArr: false,
						data: {
							name: item.setting.name,
							shownameflag: item.setting.shownameflag,
							template: item.setting.template,
							dataList: item.dataList
						}
					}
					arr.push(row)
				}
				if (item.setting.type === 7) {
					let row = {
						type: 7,
						name: '精品推荐',
						num: 0,
						allNum: 1,
						chooseArr: false,
						data: {
							dataList: [{
								imgurl: item.dataList[0].imgurl,
								chartid: item.dataList[0].chartid
							}]
						}
					}
					arr.push(row)
				}
			})
			return arr
		},
		initShowArr (template, pattern, dataList) {
			let num = template === 1 ? 4 : 5
			let arr = []
			if (pattern === 2) {
				for (let i = 0; i < dataList.length; i = i + num) {
					arr.push(dataList.slice(i, i + num))
				}
			} else {
				let num1 = 2 * num
				for (let i = 0; i < dataList.length; i = i + num1) {
					arr.push(dataList.slice(i, i + num1))
				}
			}
			return arr
		},
		selectClick (data, index) {
			for (let i = 0; i < this.homeArr.length; i++) {
				this.homeArr[i].chooseArr = (index === i)
			}
			this.$refs.componentBox.initData(data)
		},
		end1 (e) {
			let list = [
				{
					type: 2,
					name: '公告',
					num: 0,
					allNum: 1,
					chooseArr: false,
					data: {
						useway: 1,
						disabledflag: 0,
						detail: ''
					}
				},
				{
					type: 3,
					name: '图片广告',
					num: 0,
					allNum: 1,
					chooseArr: false,
					data: {
						template: 2,
						dataList: []
					}
				},
				{
					type: 5,
					name: '商品组',
					num: 0,
					allNum: 1,
					chooseArr: false,
					data: {
						name: '',
						template: 2,
						dataList: []
					}
				}
			]
			list.forEach(item => {
				item.num = this.homeArr.filter((data) => {
					return 	data.type === item.type
				}).length
			})
			this.componentList = JSON.parse(JSON.stringify(list))
		},
		start2 () {
			this.disable = true
		},
		end2 (e) {
			this.disable = false
		},
		onMove (e, originalEvent) {
			return true
		}
	}
}
</script>

<style lang="stylus" scoped>
.homePageSetting-body{
	font-family: Microsoft YaHei;
	flex: 1
	display flex
	flex-direction column
	padding-left: 0 !important;
	background-color: #eceffc !important;
	.hidden-box{
		overflow: hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
		word-break: break-all
	}
	.nav{
		.item-box{
			flex-shrink: 0;
			height: 100px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: space-around
		}
		.item-4{
			width: 25% !important;
		}
		.item-5{
			width: 20% !important
		}
		.item-img-box{
			display: flex;
			align-items: center;
			justify-content: center;
			height: 50px
		}
		.nav-box-1{
			min-height: 100px;
			display: flex;
			overflow: hidden;
			flex-direction: row;
		}
		.nav-box-2{
			min-height: 200px;
		}
	}
	.recommendation-1-box{
		width:100%;
		height: 168px;
		background-color: #F1F3F6
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-around;
		box-sizing: border-box
		.item-box{
			width: 166px;
			height: 166px;
			border-radius: 6px;
			background-color: #ffffff;
			display:flex;
			align-items: center;
			justify-content: center
			.defaultImg{
				width: 55px !important;
				height: 55px !important;
			}
		}
	}
	.recommendation-2-box{
		width:100%;
		height: 117px;
		background-color: #F1F3F6
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-around
		box-sizing: border-box
		.item-box{
			width: 110px;
			height: 110px;
			border-radius: 6px;
			background-color: #fff;
			display:flex;
			align-items: center;
			justify-content: center
			.defaultImg{
				width: 36px !important;
				height: 36px !important;
			}
		}
	}
	.recommendation-3-box{
		box-sizing: border-box
		height: 352px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-around
		.item-box{
			width: 100%;
			height: 100%;
			border-radius: 6px;
			background-color: #fff;
			display:flex;
			align-items: center;
			justify-content: center
			.defaultImg{
				width: 55px !important;
				height: 55px !important;
			}
		}
	}
	.recommendation-4-box{
		box-sizing: border-box
		height: 238px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-around
		.item-box{
			width: 100%;
			height: 100%;
			border-radius: 6px;
			background-color: #fff;
			display:flex;
			align-items: center;
			justify-content: center
			.defaultImg{
				width: 55px !important;
				height: 55px !important;
			}
		}
	}
	.recommendation-5-box{
		box-sizing: border-box
		height: 269px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-around
		.item-box{
			width: 100%;
			height: 100%;
			border-radius: 6px;
			background-color: #fff;
			display:flex;
			align-items: center;
			justify-content: center
			.defaultImg{
				width: 55px !important;
				height: 55px !important;
			}
			.defaultImg1{
				width: 33px !important;
				height: 33px !important;
			}
		}
	}
	.recommendation-6-box{
		box-sizing: border-box
		height: 352px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-around
		.item-box{
			width: 166px;
			height: 166px;
			border-radius: 6px;
			background-color: #fff;
			display:flex;
			align-items: center;
			justify-content: center
			.defaultImg{
				width: 55px !important;
				height: 55px !important;
			}
		}
	}
	.phone-component{
		.item-box{
			img{
				width:100%;
				height:100%
			}
		}
		position: relative
		.phone-component-text {
			width: 95px;
			position: absolute;
			left: -105px;
			top: 0;
		}
		.phone-component-btn-box{
			width:40px;
			align-items: center;
			justify-content: space-around;
			box-sizing: border-box;
			height: 108px;
			border-radius: 2px;
			background-color: #fff;
			box-shadow: 1px 1px 6px 0px rgba(71, 71, 71, 0.2);
			position: absolute;
			right: -45px;
			top: 0;
			display: flex;
			flex-direction: column;
			img{
				width: 22px;
				height: 22px;
			}
		}
	}
	.nav{
		.el-carousel__item{
			display: flex !important;
			align-items: flex-start !important;
			justify-content: flex-start !important;
		}
		.nav-box-2{
			.el-carousel__item{
				display: flex !important;
				align-items: flex-start !important;
				justify-content: flex-start !important;
				flex-wrap: wrap
			}
		}
	}
	.el-carousel__item{
		display: flex !important;
		align-items: center !important;
		justify-content: center !important;
	}
	.margin-right-10{
		margin-right: 10px
	}
	.top-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background-color: #fff;
		padding:0 20px;
		border-bottom: 1px solid #dce2fd;
		line-height: 50px;
		.top-left-box {
			display: flex;
			align-items: center;
			.scheme-name {
				font-size: 14px;
				margin: 0 10px
			}
			.shop-text {
				max-width: 500px;
				text-overflow: ellipsis;
				overflow: hidden;
				white-space: nowrap;
			}
		}
		.el-icon-back {
			border-radius 50%
			text-align: center;
			background: #9da6af;
			cursor pointer;
			padding: 3px
		}
		.el-icon-back:before {
			content: "\E6EA";
			color: #fff;
			font-weight: bold;
		}
	}
	.fx-header{
		background-color: #fff;
		padding:0 20px;
		&.header-box {
			height: 50px;
			min-height: 50px;
			line-height: 50px;
			.header-title {
				font-size: 14px;
			}
		}
	}
	.save-btn-box{
		height: 100%;
		align-items: center;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		padding:0 0 0 40px;
		.switch-tetx{
			font-size: 14px;
			font-weight: 400;
			color: #333333;
		}
	}
	.isSelect {
		border: 2px solid var(--fx-primary-color) !important
	}
	.body-box {
		margin-top: 10px;
		width: 100%;
		height: 100%;
		display: flex;
		flex-flow: row;
		justify-content: start;
		overflow: hidden
	}
	.home-page-left{
		box-sizing: border-box;
		height: 100%;
		width: 250px;
		padding:0 20px;
		background-color: #fff;
		display: flex;
		flex-direction: column
		.component-title{
			cursor: pointer;
			display: flex;
			height:60px;
			align-items: center;
			font-size: 14px;
			font-weight: 400;
			padding-left: 15px;
			color: #333333;
		}
		.component-box{
			display: flex
			flex-direction: row;
			justify-content: space-between;
			flex-wrap: wrap
			.item-box{
				width: 80px;
				height: 100px;
				display: flex;
				flex-direction: column;
				flex-shrink: 0;
				margin-right:5px;
				margin-bottom:5px;
				align-items: center;
				justify-content: center
				img{
					width: 30px;
					height: 30px;
					margin-bottom: 5px;
				}
			}
		}
	}
	.home-page-center{
		flex:1;
		height: 100%;
		background-color: #fff;
		overflow: auto;
		margin:0 10px;
		display: flex;
		justify-content: center
		.phone{
			box-sizing: border-box;
			overflow-x: hidden;
			width:100%;
			margin-top: 5%;
			height: 90%;
			overflow-y: auto;
			display: flex;
			flex-direction: column;
			align-items: center
		}
	}
	.progroup-box{
		width: 100%;
		background-color: #fff;
		text-align:left
		img{
			width: 100%;
		}
	}
	.notice-box{
		width:100%;
		height:50px;
		background-color: #FFFFFF;
		box-sizing: border-box;
		padding: 5px 10px;
	}
	.notice-container{
		width: 100%;
		height: 100%;
		background-color: #F9F9F9;
		box-sizing: border-box;
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 0 10px;
		img{
			width: 22px;
			height: 22px;
		}
	}
	.advert-img{
		width: 100%;
		height: 100px;
		background-color: #F1F3F6;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center
		color: #999999
		.defaultImg{
			width: 60px;
			height: 45px;
		}
	}
	.recommendation-box{
		background-color: #fff;
		width:100%;
		text-align:left
	}
	.progroup-title{
		left:10px;
		position: relative;
		display: inline-block;
		height: 35px;
		font-weight: bold;
		color: #333333;
	}
	.title-img{
		position: absolute;
		width: 100%;
		height: 8px;
		background: #EDAFAD;
		border-radius: 4px 0px 4px 0px;
		bottom: 5px;
		z-index: 0;
	}
	.title-name{
		position: relative;
		width: 100%;
		height: 35px;
		top: 7px;
		font-size: 14px;
	}
	.home-page-right{
		height: 100%;
		width: 440px;
		overflow: auto;
		background-color: #fff
	}
	// 拖拽css
	.chosen{
		background-color: var(--fx-primary-color) !important;
		opacity: 1 !important;
		color: white;
	}
	.ghost{
		background-color: var(--fx-primary-color) !important;
		display: flex;
		align-items: center;
		flex-direction: column;
		color: white;
	}
	.itxst {
		display: flex;
		flex-direction: row;
		margin: 10px;
		text-align :left;
	}
}

</style>
<style lang="stylus">
.el-carousel__button{
	width: 10px !important
}
.error-box {
	line-height: 30px;
	max-height: 400px;
	overflow-y: auto
}
</style>

